module.exports = __webpack_public_path__ + "static/hero-5e9cb8be2f0458cdb8fd71d7d2186bc5.png";